import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { Organization } from 'src/app/domain/organization/dto/Organization';
import { PerformanceMA } from '../dto/PerformanceMA';
import { VintageYear } from '../dto/VintageYear';
import { LocalDate } from '../../../../../core/pojo/date-variable';


export class MaReportedPeriod {
  period: LocalDate;
  isReported: boolean;
  iconNameAndStyling1: string;
}

export interface MaRound {
  companyId: number;
  companyName: string;
  orgName: string;
  sector: string;
  roundName: string;
  roundDate: Date;
  cost: number;
  fmv: number;
  totalRound: number;
  postMoney: number;
  fundId: number;
}


export class MaSelectedItems {
  period: LocalDate = null;
  org?: Organization = null;
  tab?: string = '';
  vintageFrom?: LocalDate;
  vintageTill?: LocalDate;
}

export class MaShowItems {
  loadingState = true; // show or hide components skeleton
  topFiveSection = new MaShowTopFiveSection();
}

export class MaShowTopFiveSection {
  capitalRaised = true;
  numberOfDeals = false;
}


export enum MaSections {
  MA_BY_IND_TOP_FIVE
}

export enum MaSelectedCharts {
  MA_BY_IND_TOP_FIVE_CAPITAL_RAISED,
  MA_BY_IND_TOP_FIVE_NUM_DEALS,
}

export class MaDates {
  periodInfo: MaReportedPeriod[] = [];
  copySettings = new MaCopySettingsDates();
  vintageYears: VintageYear[] = [];
}

export class MaCopySettingsDates {
  publishedPeriods: LocalDate[] = [];
  selectedPeriod: LocalDate;
}

export class IsMa {
  vintageMenuVisible = false;
  anyVintage = false;
  allFundsSelected = true;
}

export class ShowMa {
  copySettingsModal = false;
  topFiveSection = new MaShowTopFiveSection();
}

export class MaFund {
  isSelected = false;
  name?: string;
  registrationDate?: Date;
  initialClosing?: Date;
  vintageYear?: string;
  totalCommitment = 0;
  contributionReceivedPercent = 0;
  contributionReceived = 0;
  totalExpenses? = 0;
  netGainLoss = 0;
  navAndDistribution = 0;
  tvpi = 0;
  distribution = 0;
  dpi = 0;
  netIrr: number = null;
  amountOfCompanies = 0;
  investment = 0;
  value = 0;
  grossIrr: number = null;
  amountOfSoldCompanies = 0;
  soldInvestment = 0;
  soldValue = 0;
  soldIrr: number = null;
  fundId?: number;
}

export class MaFundsTable {
  main: MaFund[];
  totals: MaFund;
}

export class MaRecoveryDTO {
  fundsTable: MaFundsTable;
  roundsTable: MaRoundsTable;
  selectorRoundsYears: string[];
}

export class MaRoundsTable {
  allRounds: MaRound[];
  performanceByCompany: PerformanceMA[];
  performanceByIndustry: PerformanceMA[];
}

export class MaRecoverySetUpDTO {
  fundIds: number[];
  periodInfo: MaReportedPeriod;
  constructor() {
    this.fundIds = [];
    this.periodInfo = new MaReportedPeriod();
  }
}

export type MaRecoveryFormGroup = FormGroup<{
  periodInfo: FormControl<MaReportedPeriod>;
  fundIds: FormArray<FormControl<number>>;
}>;

export class MaFundIds {
  all: number[];
  selected: number[];

  constructor(all: number[] = [], selected: number[] = []) {
    this.all = all;
    this.selected = selected;
  }
}

export enum MaReportAction {
  Save = 'SAVE',
  Delete = 'DELETE',
  Republish = 'REPUBLISH',
  CopySettings = 'COPY SETTINGS',
}

export enum MaFundsDataTables {
  Moic = 'Moic',
  Tvpi = 'Tvpi',
  Irr = 'Irr',
  NetIrr = 'NetIrr',
  Contribution = 'Contribution',
  Dpi = 'Dpi'
}
